import {
    REQUEST_USERS
} from "@actions/actionTypes";

export function getUsers() {
    return dispatch => {
        dispatch({type: REQUEST_USERS});
    }
}